// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3XhTs","title":"styles_title__1FxJb"};